import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Icon, Menu } from '@percent/lemonade'
import type { VolunteeringActivity } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'

export type ActivityTagActionsMenuProps = Readonly<{
  tag: VolunteeringActivity
  onEdit: (tag: VolunteeringActivity) => void
}>

export function ActivityTagActionsMenu({ tag, onEdit }: ActivityTagActionsMenuProps) {
  const { t } = useTranslation()

  const items = useMemo(
    () => [
      {
        key: 'edit',
        label: t('button.edit'),
        dataTestId: 'edit-activity-tag-menu-item'
      }
    ],
    [t]
  )

  const onSelect = (key: string) => {
    if (key === 'edit') {
      onEdit(tag)
    }
  }

  return (
    <Menu
      title={<Icon name="menu-vertical" size={6} customTestId="activity-tag-actions-menu" />}
      onSelect={onSelect}
      sections={[{ items }]}
    />
  )
}
